import React, { useEffect } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import api from "../../services/api";

const { Option } = Select;

const TeamFormModal = ({
  open,
  onClose,
  onSuccess,
  players = [],
  initialData = null,
}) => {
  const [form] = Form.useForm();
  const isEditing = !!initialData;

  /* -------------------- PREFILL (EDIT MODE) -------------------- */
  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        name: initialData.name,
        captain_id: initialData.captain_id || undefined,
      });
    }
  }, [initialData, form]);

  /* -------------------- SUBMIT -------------------- */
  const handleSubmit = async (values) => {
    try {
      let res;

      if (isEditing) {
        res = await api.put(
          `/teams/${initialData.team_id}`,
          values
        );
        message.success("Team updated successfully");
      } else {
        res = await api.post("/teams", values);
        message.success("Team created successfully");
      }

      form.resetFields();

      // 🔁 Return created/updated team to parent
      onSuccess?.(res.data.data);

      onClose();
    } catch (error) {
      console.error("Team save failed", error);
      message.error("Failed to save team");
    }
  };

  return (
    <Modal
      open={open}
      title={isEditing ? "Edit Team" : "Create Team"}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={() => form.submit()}
      okText={isEditing ? "Update" : "Create"}
      width={420}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        {/* TEAM NAME */}
        <Form.Item
          name="name"
          label="Team Name"
          rules={[
            { required: true, message: "Please enter team name" },
          ]}
        >
          <Input placeholder="Enter team name" />
        </Form.Item>

        {/* CAPTAIN (OPTIONAL) */}
        <Form.Item
          name="captain_id"
          label="Captain (optional)"
        >
          <Select
            placeholder="Select captain"
            allowClear
          >
            {players.map((p) => (
              <Option key={p.player_id} value={p.player_id}>
                {p.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TeamFormModal;
